import { configureStore } from '@reduxjs/toolkit';

import { authReducer, AuthState } from './slices/authSlice';
import { uiReducer, UIState } from './slices/uiSlice';
import { ordersReducer, OrdersState } from './slices/ordersSlice';
import { usersReducer, UsersState } from './slices/usersSlice';
import { productsReducer, ProductsState } from './slices/productsSlice';
import { acfReducer, AcfState } from './slices/acfSlice';
import { assetValuesReducer, AssetValuesState } from './slices/assetValuesSlice';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        ui: uiReducer,
        orders: ordersReducer,
        users: usersReducer,
        products: productsReducer,
        acf: acfReducer,
        assetValues: assetValuesReducer,
    },
});

export interface RootState {
    auth: AuthState;
    ui: UIState;
    orders: OrdersState;
    users: UsersState;
    products: ProductsState;
    acf: AcfState;
    assetValues: AssetValuesState;
}

export type AppDispatch = typeof store.dispatch;
